import React, { useCallback, useEffect, useRef, useState } from "react";
import DynamicTable from "../../../common/DynamicTable";
import { useAppDispatch, useAppSelector } from "../../../app/hooks";
import { getFiltersByReportAsync, generateReportAsync, updateOrigReportDataState } from "./CustomReportViewSlice";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import '../../../common/css/timeLive.css'
import Loader from "../../../common/Loader";
import { CustomReportFilter } from "./CustomReportFilter";
import OffCanvas from "../../../common/OffCanvas";
import { Dropdown } from 'react-bootstrap';
import { generatePDF1 } from "../../../common/generatePDF";
import Select, { StylesConfig } from 'react-select';
import { useTranslation } from "react-i18next";
import { formatNumberCustomoriginal, formatNumberCustomoriginalapiv2, getFilteredList, getPageSizeArray, paginationStyles, getNestedFilteredList, getValueFromResource, formatCurrntDateTime, formatDateWithDateAndMonthName, FormatInvoiceDecimalNumber } from "../../../common/timeLiveFunction";
import * as XLSX from 'xlsx';
import GenericHtmlToPdfDownloader from "../../../common/GenericHtmlToPdfDownloader";
import { MyReports } from "../myReports/MyReports";
import { CSVLink } from "react-csv";
import { toAbsoluteUrl } from "../../../_metronic/helpers";
import { boolean } from "yup";
import MUITableView from "./MUITableView";
import MUISimpleTableView from "./MUISimpleTableView";
import fetchAPI from "../../../common/fetchAPI";
import ScheduleReport from "./ScheduleReport";
import { getAccountFeatureAsync } from "../../../common/GlobalSlice";



export const CustomReportView = () => {

  const dispatch = useAppDispatch();
  // const location = useLocation();
  const { t } = useTranslation();

  const [reportDataArray, setReportDataArray] = useState<any | ''>([]);
  const [reportDataArrayDummy, setReportDataArrayDummy] = useState<any | ''>([]);
  const [reportGroupDataArray, setReportGroupDataArray] = useState<any | ''>([]);
  const [reportColumnsDataArray, setReportColumnsDataArray] = useState<any | ''>([]);
  const [overallTotalsArray, setOverallTotalsArray] = useState<any | ''>([]);
  const [reportSummaryDataArray, setReportSummaryDataArray] = useState<any | ''>([]);
  const [currentItems, setCurrentItems] = useState<any | ''>([]);
  const [pageOptions, setPageOptions] = useState<any | ''>([]);
  const [selectedFilters, setSelectedFilters] = useState<any | ''>([]);
  const [reportId, setReportId] = useState<any | ''>("");
  const [groupReportLabel, setGroupReportLabel] = useState<any | ''>("");
  const [resourceName, setResourceName] = useState('');
  const [showScheduleTab, setShowScheduleTab] = useState(false);
  const csvLinkRef = useRef<any>();

  // Constants for page and row height
  const rowMaxHeight = 20; // Row height in pixels
  const pageHeightMM = 297; // A4 page height in mm
  const mmToPx = 3.7795275591; // Conversion factor from mm to px
  const pageHeightPx = pageHeightMM * mmToPx; // A4 page height in px
  //const rowsPerPage = Math.floor(pageHeightPx / rowHeight); // Rows per page based on row height
  const [rowsPerPage, setRowsPerPage] = useState(0);
  //const [rowMaxHeight, setRowMaxHeight] = useState(19);

  const [pageSize, setPageSize] = useState(rowsPerPage);
  const [currentPage, setCurrentPage] = useState(1);
  const [searchTerm, setSearchTerm] = useState('');
  const [totalPages, setTotalPages] = useState(0);
  const [maxRowIndex, setMaxRowIndex] = useState(-1);

  const [isConsolidated, setIsConsolidated] = useState<boolean>(false);
  const [isPdfExport, setIsPdfExport] = useState<boolean>(false);
  const [iscsvExport, setIscsvExport] = useState<boolean>(false);
  const [isxlsExport, setIsxlsExport] = useState<boolean>(false);
  const [isFirstTimeLoad, setIsFirstTimeLoad] = useState<boolean>(true);
  const [isGenerateReportActive, setIIsGenerateReport] = useState<boolean>(false);
  const [isLoadingLocal, setIsLoadingLocal] = useState<boolean>(false);
  const [isGeneratePdf, setIsGeneratePdf] = useState<boolean>(false);

  const contentRef = useRef<HTMLDivElement>(null);
  const contentRef1 = useRef<HTMLDivElement>(null);
  const tableRef = useRef<HTMLDivElement>(null);
  const [SelectedExportData, setSelectedExportData] = useState('');
  const [SelectedFileName, setSelectedFileName] = useState('');
  const [SelectedColumnHeaders, setSelectedColumnHeaders] = useState<any | ''>([]);
  const [isShowLogoInReport, setIsShowLogoInReport] = useState<boolean>(false);
  const [logoURL, setLogoURL] = useState<string>("");
  const navigate = useNavigate();
  const { state } = useLocation();
  const [imageLoaded, setImageLoaded] = useState(false);
  const [groupData, setGroupData] = useState({});
  const [simpleData, setSimpleData] = useState({});
  const [isShowLoader, setIsShowLoader] = useState(false);
  const [showScheduleReport, setShowScheduleReport] = useState(false);
  const handleImageLoad = () => {
    setImageLoaded(true);
  };

  const { AccountReportId } = useParams();

  const overallTotals: any = [];

  const { selectedRecord, isLoading, filterList, isReload, filterDropDownList, ReportName, reportData } = useAppSelector((state) => state.customReportView);
  const { cultureInfoName, decimalPlaces, isCompanyOwnLogo } = useAppSelector(state => state.globalState);

  // Calculate the total number of records in each property
  const calculateTotals = (data: any) => {
    const totalsObject: any = {};
    let total: any = 0;

    for (const property in data) {
      if (data[property].items) {
        totalsObject[property] = data[property].items.length;
        total += data[property].items.length;
      } else {
        totalsObject[property] = 0;
      }
    }
    return total;
  };

  useEffect(() => {
    if (SelectedFileName) {
      if (csvLinkRef.current) {
        csvLinkRef.current.link.click();
      }
    }

  }, [SelectedFileName])

  useEffect(() => {
    const response = dispatch(getFiltersByReportAsync(AccountReportId)).unwrap().then((snap) => {
      const resource = JSON.parse(snap?.Data?.FilterData)
      setResourceName(resource[0]?.ReportDataSourceName)
    })
      .catch((err) => {
        console.log(err);
      })
  }, [])

  useEffect(() => {
          dispatch(getAccountFeatureAsync()).then((res: any) => {
              if (res?.meta?.requestStatus === 'fulfilled') {
                  const data = res?.payload?.AccountFeatures || [];
                  const hasScheduleFeature = data.some((item: any) => item.SystemFeatureId?.toLowerCase() === "356282ab-9aa8-45ae-8d2c-b1a7453a93d4");
                  setShowScheduleTab(hasScheduleFeature);
              }
          })
              .catch((error) => {
                  console.log(error);
              })
      }, []);

  useEffect(() => {
    let totalPagesLocal = 0;
    if (typeof reportDataArray === 'object' && !Array.isArray(reportDataArray) && reportDataArray !== null) {
      totalPagesLocal = Math.ceil(calculateTotals(reportDataArray) / Math.floor(pageHeightPx / rowMaxHeight));
    }
    else {
      totalPagesLocal = Math.ceil(reportDataArray.length / Math.floor(pageHeightPx / rowMaxHeight));
    }
    setPageOptions(Array.from({ length: totalPagesLocal }, (_, index) => ({
      value: index + 1,
      label: `${index + 1}`
    })));
    setTotalPages(totalPagesLocal);
    //setRowMaxHeight(rowMaxHeight);
    setRowsPerPage(Math.floor(pageHeightPx / rowMaxHeight));

    // Calculate the start and end index for the current page
    const startIndex = (currentPage - 1) * rowsPerPage;
    const endIndex = startIndex + rowsPerPage;
    let filteredData: any = [];

    if (typeof reportDataArray === 'object' && !Array.isArray(reportDataArray) && reportDataArray !== null) {
      filteredData = getNestedFilteredList(reportDataArray, searchTerm, startIndex, endIndex);
      setCurrentItems(filteredData);
    }
    else {
      filteredData = getFilteredList(reportDataArray, searchTerm);
      setCurrentItems(filteredData.slice(startIndex, endIndex));
    }
    setIsGeneratePdf(false);
  }, [isGeneratePdf, rowsPerPage, searchTerm, pageSize, currentPage])

  useEffect(() => {
    if (reportId.toLowerCase() === "3003299d-18bb-41ae-ac21-204cf6a372a1") {
      if (isxlsExport) {
        exportxls();
      }
    } else {
      if (isxlsExport) {
        if (contentRef1.current) {
          const originalWs = XLSX.utils.table_to_sheet(contentRef1.current);

          const titleRow = [[`${contentRef1.current.querySelector('.reportTitle')?.innerHTML}`]];

          // Extract table data
          const tableData: any[] = XLSX.utils.sheet_to_json(originalWs, { header: 1 });

          // Find all columns that have "Date" in their header
          const headerRow: string[] = tableData[0] as string[];
          const dateColumnIndexes: number[] = headerRow.reduce((indexes: number[], col: string, index: number) => {
            if (col?.toLowerCase().includes("date")) {
              indexes.push(index);
            }
            return indexes;
          }, []);

          // Loop through data and format date columns
          tableData.forEach((row: any[], index: number) => {
            if (index > 0) {  // Ignore header row
              dateColumnIndexes.forEach((dateIndex: number) => {
                let dateValue = row[dateIndex];

                if (typeof dateValue === 'number') {
                  // Convert Excel serial number to proper date
                  const excelEpoch = new Date(1899, 11, 30); // Excel date epoch
                  dateValue = new Date(excelEpoch.getTime() + dateValue * 86400000)
                    .toISOString().split("T")[0];
                } else if (typeof dateValue === 'string' && !isNaN(Date.parse(dateValue))) {
                  dateValue = new Date(dateValue).toISOString().split("T")[0];
                }

                row[dateIndex] = dateValue;
              });
            }
          });

          // Ensure title row spans all columns
          const titleRowFormatted = [Array(headerRow.length).fill("")];
          titleRowFormatted[0][0] = titleRow[0][0]; // Set the title in the first column

          const finalData = [...titleRowFormatted, ...tableData];

          // Create new worksheet
          const combinedWs = XLSX.utils.aoa_to_sheet(finalData);

          // Apply date format dynamically
          dateColumnIndexes.forEach((dateIndex: number) => {
            const colLetter = String.fromCharCode(65 + dateIndex); // Convert index to column letter
            Object.keys(combinedWs).forEach((cell: string) => {
              if (cell.startsWith(colLetter)) {
                combinedWs[cell].z = "yyyy-mm-dd";
              }
            });
          });

          // Create workbook
          const wb = XLSX.utils.book_new();
          XLSX.utils.book_append_sheet(wb, combinedWs, 'LiveReport');

          // Download file
          XLSX.writeFile(wb, 'LiveReport.xlsx');

          setTimeout(() => {
            setIsLoadingLocal(false);
            setIsxlsExport(false);
          }, 500);
        }
      }
    }
  }, [isxlsExport]);

  const exportxls = () => {
    if (reportDataArray) {
      const excelData: any[] = [];
      excelData.push([groupReportLabel]);

      Object.entries(reportDataArray).forEach(([employeeName, employeeData]: [string, any]) => {
        excelData.push([employeeName]);
        employeeData.items.forEach((item: any) => {
          excelData.push([
            " ",
            item['1'] || '',
            item['2'] || '',
            item['3'] || '',
            item['4'] || '',
            item['5'] || ''
          ]);
        });
        excelData.push([]);
      });

      const worksheet = XLSX.utils.aoa_to_sheet(excelData);
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, 'LiveReport');
      XLSX.writeFile(workbook, 'LiveReport.xlsx');

      setTimeout(() => {
        setIsLoadingLocal(false);
        setIsxlsExport(false);
      }, 500);
    }
  };


  useEffect(() => {
    if (isPdfExport) {
      if (contentRef1.current || contentRef.current) {

        GenericHtmlToPdfDownloader(contentRef1, "LiveReport").then((result) => {
          setIsLoadingLocal(false);
          setIsPdfExport(false);
        }).catch((error) => {
          setIsLoadingLocal(false);
          setIsPdfExport(false);
        });

      }
    }
  }, [isPdfExport])

  useEffect(() => {
    if (reportId.toLowerCase() === "3003299d-18bb-41ae-ac21-204cf6a372a1") {
      if (iscsvExport) {
        setTimeout(() => {
          exportCSV();
          setIsLoadingLocal(false);
          setIscsvExport(false);
        }, 500);
      }
    } else {
      if (iscsvExport) {
        setTimeout(() => {
          // this code is done by Ahmed bhai

          // this code is done by Atique first we are converting data into json by XLSX then that json will be use for generating csv report 
          if (contentRef1.current) {
            const table = contentRef1.current.querySelector('table');
            if (table) {
              const originalWs = XLSX.utils.table_to_sheet(table);

              // Convert worksheet to JSON
              type TableDataRow = (string | number | null | undefined)[];
              const tableData = XLSX.utils.sheet_to_json(originalWs, { header: 1 }) as TableDataRow[];
              const title = contentRef1.current.querySelector('.reportTitle')?.innerHTML || 'LiveReport';
              const headerRow: string[] = tableData[0] as string[];
              const dateColumnIndexes: number[] = headerRow.reduce((indexes: number[], col: string, index: number) => {
                if (col?.toLowerCase().includes("date")) {
                  indexes.push(index);
                }
                return indexes;
              }, []);

              tableData.forEach((row: any[], index: number) => {
                if (index > 0) {
                  dateColumnIndexes.forEach((dateIndex: number) => {
                    let dateValue = row[dateIndex];

                    if (typeof dateValue === 'number') {
                      // Convert Excel serial number to proper date
                      const excelEpoch = new Date(1899, 11, 30); // Excel date epoch
                      dateValue = new Date(excelEpoch.getTime() + dateValue * 86400000)
                        .toISOString().split("T")[0];
                    } else if (typeof dateValue === 'string' && !isNaN(Date.parse(dateValue))) {
                      dateValue = new Date(dateValue).toISOString().split("T")[0];
                    }

                    row[dateIndex] = dateValue;
                  });
                }
              });

              // Add the title row
              const titleRow = [[title]];
              const sanitizedTableData = tableData.map((row: any[]) =>
                row.map((cell: any) => (cell === undefined || cell === null ? "" : cell))
              );
              const finalData = [...titleRow, ...sanitizedTableData];

              // Convert JSON to CSV
              let csvContent = finalData.map((row: any) =>
                row.map((cell: any) => `"${cell}"`).join(',')
              ).join('\n');

              // Download CSV
              const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
              const url = URL.createObjectURL(blob);
              const link = document.createElement('a');
              link.href = url;
              link.download = 'LiveReport.csv';
              document.body.appendChild(link);
              link.click();
              document.body.removeChild(link);
            }
          }
          setIsLoadingLocal(false);
          setIscsvExport(false);
        }, 500);
      }
    }
  }, [iscsvExport]);
  const exportCSV = () => {
    if (!reportDataArray) return;

    let csvContent = '';
    csvContent += `"${groupReportLabel}"\n`;
    Object.entries(reportDataArray).forEach(([employeeName, employeeData]: [string, any]) => {
      csvContent += `"${employeeName}"\n`;
      employeeData.items.forEach((item: any) => {
        const row = [
          "",
          `"${item['1']}"`,
          `"${item['2']}"`,
          `"${item['3']}"`,
          `"${item['4']}"`,
          `"${item['5']}"`
        ]
        csvContent += row + '\n';
      });
      csvContent += '\n';
    });

    // Create and trigger download
    const blob = new Blob([csvContent], { type: 'text/csv' });
    const url = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = 'LiveReport.csv';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  // }, [iscsvExport])
  const handleSearch = (event: any) => {
    const { value } = event.target;
    setSearchTerm(value);
    setCurrentPage(1);
  };

  // Calculate total pages
  const handlePageChange = (selectedOption: any) => {
    const { value, label } = selectedOption;
    if (value >= 1 && value <= totalPages) {
      setCurrentPage(value);
    }
  };

  function isNested(data: any) {
    // Check if the data is an object and not an array
    if (typeof data === 'object' && !Array.isArray(data) && data !== null) {
      // Check if any value in the object is another object
      return Object.values(data).some(value => typeof value === 'object' && value !== null);
    }

    // Check if the data is an array
    if (Array.isArray(data)) {
      // Check if any element in the array is an object
      return data.some(item => typeof item === 'object' && item !== null);
    }

    // If none of the above conditions are met, the data is not nested
    return false;
  }

  const getCustomFieldTemplateByMasterEntityTypeIdAsync = async (MasterEntityTypeId: string) => {
    // let MasterEntityTypeId: string = '13DBFF37-A092-4AE2-A919-775CBED0EDC0';
    const response = await fetchAPI('api/v2/CustomFields/CustomFieldTemplateByMasterEntityType/' + MasterEntityTypeId, 'GET', '', true, "");
    const json = await response.json();
    return json;
  }

  function groupDataByMultipleColumns(tableData: any, groupByColumns: any, reportSummary: any, amountField = "Amount", shouldCalculateTotal = false) {
    return tableData.reduce((accumulator: any, item: any) => {
      const sortedData = groupByColumns.sort((a: any, b: any) => {
        // Check if the sequence field is zero for either object
        if (a.ReportGroupFieldOrder === 0 && b.ReportGroupFieldOrder === 0) {
          // If both have zero sequence, no change in order
          return 0;
        } else if (b.ReportGroupFieldOrder === 0) {
          // Objects with zero sequence go to the start
          return -1;
        } else if (a.ReportGroupFieldOrder === 0) {
          // Objects with zero sequence go to the start
          return 1;
        }
        // Sort other objects based on sequence
        return b.ReportGroupFieldOrder - a.ReportGroupFieldOrder;
      });

      // const groupValues = sortedData.map((column: any) => item[column.SystemReportDataSourceField]).join(','); // Combine group values into a single key
      const groupValues = sortedData.map((column: any) => item[column.SystemReportDataSourceField]).join('/\\');
      if (!accumulator[groupValues]) {
        accumulator[groupValues] = {
          totals: [], // Use an object to store totals for each field
          items: [],
        };
      }

      if (shouldCalculateTotal) {
        let fieldValue: any = 0;
        const distinctArray = Array.from(new Set(reportSummary.map((item: any) => item.SystemReportDataSourceField))).map(SystemReportDataSourceField => reportSummary.find((item: any) => item.SystemReportDataSourceField === SystemReportDataSourceField));
        distinctArray.forEach((field: any) => {
          if (field.IsShowGroupTotal) {
            if (!Object.keys(distinctArray).includes(field.SystemReportDataSourceField) || !Object.keys(distinctArray).includes(field.SystemReportDataSourceField) || field.SystemReportDataSourceField.substring(0, 1) !== "'") {
              if (field.CalculationType === "Sum") {
                if (!accumulator[groupValues].totals[field.SystemReportDataSourceField]) {
                  accumulator[groupValues].totals[field.SystemReportDataSourceField] = 0;
                }
                fieldValue = item[field.SystemReportDataSourceField] || 0;
                accumulator[groupValues].totals[field.SystemReportDataSourceField] += fieldValue;
              }
              else if (field.CalculationType === "Count") {
                if (!accumulator[groupValues].totals[field.SystemReportDataSourceField]) {
                  accumulator[groupValues].totals[field.SystemReportDataSourceField] = 0;
                }
                else {
                  accumulator[groupValues].totals[field.SystemReportDataSourceField] += 1;
                }
              }
            }
          }
          if (field.IsShowGrandTotal) {
            if (!Object.keys(distinctArray).includes(field.SystemReportDataSourceField) || !Object.keys(distinctArray).includes(field.SystemReportDataSourceField) || field.SystemReportDataSourceField.substring(0, 1) !== "'") {
              if (field.CalculationType === "Sum") {
                if (!overallTotals[field.SystemReportDataSourceField]) {
                  overallTotals[field.SystemReportDataSourceField] = 0;
                }
                overallTotals[field.SystemReportDataSourceField] += fieldValue;
              }
              else if (field.CalculationType === "Count") {
                if (!overallTotals[field.SystemReportDataSourceField]) {
                  overallTotals[field.SystemReportDataSourceField] = 0;
                }
                else {
                  overallTotals[field.SystemReportDataSourceField] += 1;
                }
              }
            }
          }
        });
      }

      accumulator[groupValues].items.push(item);
      return accumulator;
    }, {});

  }

  const ENTITY_MASTER_TYPE: Record<string, string> = {
    'Time Entry': '369ed0fb-d317-4244-9f20-b7d834521e2b',
    'TimeEntry': '369ed0fb-d317-4244-9f20-b7d834521e2b',
    'Expense Entry': '756e4460-a713-4bee-b3f0-708fc5be21bd',
    'ExpenseEntry': '756e4460-a713-4bee-b3f0-708fc5be21bd',
    'Expense Sheet': 'a55df02b-fbfb-4873-b582-6968fbaee589',
    'ExpenseSheet': 'a55df02b-fbfb-4873-b582-6968fbaee589',
    'Client': 'e448aed9-eab5-4cf7-a171-2a86be2bba9e',
    'Clients': 'e448aed9-eab5-4cf7-a171-2a86be2bba9e',
    'Department': '58712c84-b0c9-4b28-982a-dc922aa5cbe6',
    'Departments': '58712c84-b0c9-4b28-982a-dc922aa5cbe6',
    'Employee': '3601ae9b-3f82-4c80-9574-751f9a124fa8',
    'Employees': '3601ae9b-3f82-4c80-9574-751f9a124fa8',
    'Project': '13dbff37-a092-4ae2-a919-775cbed0edc0',
    'Projects': '13dbff37-a092-4ae2-a919-775cbed0edc0',
    'Project Task': 'c9a8f7f1-1b2d-48da-aae9-74f92892a896',
    'Task': 'c9a8f7f1-1b2d-48da-aae9-74f92892a896',
    'Tasks': 'c9a8f7f1-1b2d-48da-aae9-74f92892a896',
  };

  const CUSTOM_FIELD_PREFIXES = [
    'TaskCustomField',
    'EmployeeCustomField',
    'ProjectCustomField',
    'ClientCustomField',
    'DepartmentCustomField',
    'ExpenseSheetCustomField',
    'ExpenseEntryCustomField',
  ];

  const mapFields = (data: any[], type: string) =>
    Array.isArray(data) ? data.map((item) => ({
      ...item,
      DatabaseFieldName: item.DatabaseFieldName?.startsWith('CustomField')
        ? item.DatabaseFieldName.replace('CustomField', type)
        : item.DatabaseFieldName,
    })) : [];

  const extractCustomFields = (columns: any[]) => columns.map((c) => c.SystemReportDataSourceField).filter(Boolean);

  const fetchCustomFields = async (fields: string[], resourceName: string) => {
    const results: any[] = [];

    for (const prefix of CUSTOM_FIELD_PREFIXES) {
      if (!fields.some((f) => f.startsWith(prefix))) continue;

      const entityName = prefix.replace('CustomField', '').trim() || resourceName;
      const entityId = ENTITY_MASTER_TYPE[entityName] || ENTITY_MASTER_TYPE[resourceName];

      if (!entityId) continue;
      const response = await getCustomFieldTemplateByMasterEntityTypeIdAsync(entityId);
      results.push(...mapFields(response, prefix));
    }

    if (fields.some((f) => f.startsWith('CustomField'))) {
      const entityId = ENTITY_MASTER_TYPE[resourceName];
      if (entityId) {
        const response = await getCustomFieldTemplateByMasterEntityTypeIdAsync(entityId);
        results.push(...(Array.isArray(response) ? response : []));
      }
    }

    return results;
  };

  const getGroupJSON = async (tableData: any[], tableHeader: any[], tableSummary: any[], tableColumns: any[], consolidated: any, companyLogo: any, showCompanyLogo: any) => {
    const fields = extractCustomFields(tableColumns);
    const allCustomFields = await fetchCustomFields(fields, resourceName);
    const reportIds = tableHeader.map((item) => item.AccountReportId);
    const uniqueReportIds = Array.from(new Set(reportIds));
    const groups = tableHeader.map((header) => {
      const matchingCol = tableColumns.find(col => col.SystemReportDataSourceField === header.SystemReportDataSourceField);
      const summaryItem = tableSummary.find(summary => summary.SystemReportDataSourceField === header.SystemReportDataSourceField);
      return {
        id: header.SystemReportDataSourceField,
        header: header.ReportGroupFieldLabel,
        accessorKey: header.SystemReportDataSourceField,
        enableGrouping: true,
        type: header?.SystemReportFieldType?.toLowerCase() || null,
        footer: summaryItem?.CalculationType || null,
      };
    });

    const columns = consolidated
      ? tableColumns.filter((col) => tableSummary.some(
        (s) => s.SystemReportDataSourceField === col.SystemReportDataSourceField && (s.CalculationType === "Sum" || s.CalculationType === "Count"))).map((col) => {
          const summaryItem = tableSummary.find(
            (s) => s.SystemReportDataSourceField === col.SystemReportDataSourceField
          );

          return {
            accessorKey: col.SystemReportDataSourceField,
            header: col.Caption,
            size: col.SystemReportDataSourceFieldWidth,
            type: col.SystemReportFieldType.toLowerCase(),
            footer: summaryItem?.CalculationType || null,
          };
        })
      : tableColumns.map((col) => {
        const summaryItem = tableSummary.find((s) => s.SystemReportDataSourceField === col.SystemReportDataSourceField);
        const matchedResponse = allCustomFields?.find((r: any) => r.DatabaseFieldName === col.SystemReportDataSourceField);

        return {
          accessorKey: col.SystemReportDataSourceField,
          header: col.Caption,
          size: col.SystemReportDataSourceFieldWidth,
          type: matchedResponse?.MasterCustomDataTypeName?.toLowerCase() === 'date' ? 'dateTime' : matchedResponse?.MasterCustomDataTypeName?.toLowerCase() || col.SystemReportFieldType.toLowerCase(),
          footer: summaryItem?.CalculationType || null,
        };
      });


    const totals: Record<string, number> = {};

    tableSummary.forEach((summary) => {
      if (summary.CalculationType === "sum") {
        totals[summary.SystemReportDataSourceField] = tableData.reduce(
          (sum, item) => sum + (Number(item[summary.SystemReportDataSourceField]) || 0),
          0
        );
      } else if (summary.CalculationType === "count") {
        totals[summary.SystemReportDataSourceField] = tableData.length;
      }
    });

    const nestedData = tableData.reduce((acc, item) => {
      const groupKeys = tableHeader.map((h) => item[h.SystemReportDataSourceField]);

      let currentLevel = acc;
      groupKeys.forEach((key, index) => {
        if (!currentLevel[key]) {
          currentLevel[key] = {
            [tableHeader[index].SystemReportDataSourceField]: key,
            subGroups: {},
            items: [],
          };
        }
        currentLevel = currentLevel[key].subGroups;
      });

      if (!currentLevel.items) {
        currentLevel.items = [];
      }
      currentLevel.items.push(item);
      return acc;
    }, {});

    return {
      config: {
        groups,
        columns,
        summaryConfig: tableSummary,
        totals,
      },
      data: nestedData,
      reportId: uniqueReportIds[0],
      consolidated,
      companyLogo,
      showCompanyLogo
    };
  };

  const getSimpleJSON = async (tableColumns: any[], tableData: any[], tableSummary: any[]) => {
    const fields = extractCustomFields(tableColumns);
    const allCustomFields = await fetchCustomFields(fields, resourceName);
    const columns = tableColumns.map((col) => {
      const summaryItem = tableSummary.find((s) => s.SystemReportDataSourceField === col.SystemReportDataSourceField);
      const matchedResponse = allCustomFields?.find((r: any) => r.DatabaseFieldName === col.SystemReportDataSourceField);

      if (col.SystemReportDataSourceField === 'OldValue' || col.SystemReportDataSourceField === 'NewValue') {
        return {
          accessorKey: col.SystemReportDataSourceField,
          header: col.Caption,
          size: col.SystemReportDataSourceFieldWidth,
          type: 'audit',
          footer: summaryItem?.CalculationType || null,
        };
      }
     
      return ({
        accessorKey: col.SystemReportDataSourceField,
        header: col.Caption,
        size: col.SystemReportDataSourceFieldWidth,
        type: matchedResponse?.MasterCustomDataTypeName?.toLowerCase() === 'date' ? 'dateTime' : matchedResponse?.MasterCustomDataTypeName?.toLowerCase() || col.SystemReportFieldType.toLowerCase(),//matchedResponse?.CustomFieldName ? matchedResponse?.MasterCustomDataTypeName?.toLowerCase() : col.SystemReportFieldType.toLowerCase(),
        footer: summaryItem?.CalculationType || null,
      })
    });
    return {
      config: {
        columns,
        groups: [],
        summaryConfig: tableSummary,
      },
      data: tableData,
    };
  };

  const handleOnClickEvent = () => {

    setIIsGenerateReport(true);
    setIsShowLoader(true);
    dispatch(generateReportAsync({ filterDropDownList: filterDropDownList, AccountReportId: AccountReportId }))
      .unwrap()
      .then(async (originalPromiseResult) => {
        if (originalPromiseResult?.Data?.imageURL) {
          const fetchedImageURL = originalPromiseResult.Data.imageURL;
          setLogoURL(fetchedImageURL);
        }
        if (originalPromiseResult?.Data?.isShowLogoInReport) {
          const Logo: boolean = originalPromiseResult?.Data?.isShowLogoInReport;
          setIsShowLogoInReport(Logo);
        }
        if (originalPromiseResult.StatusCode === "200") {
          // setIsShowLoader(false);
          if (AccountReportId === '7bf614b0-b544-444b-819b-de2790bb7a8a') {
            setSelectedColumnHeaders(originalPromiseResult.data.length > 0 ? Object.keys(originalPromiseResult.data[0]) : []);
            setSelectedExportData(originalPromiseResult.data);
            setSelectedFileName(originalPromiseResult.FileName);
            setIsShowLoader(false);
          }
          else if (AccountReportId === '5423601c-9c5e-46d3-b563-9771774b412d') {
            setSelectedColumnHeaders(originalPromiseResult.data.length > 0 ? Object.keys(originalPromiseResult.data[0]) : []);
            setSelectedExportData(originalPromiseResult.data);
            setSelectedFileName(originalPromiseResult.FileName);
            setIsShowLoader(false);
          }
          else if (AccountReportId === '08be7714-fa64-4224-81d9-642e182d433b') {
            setSelectedColumnHeaders(originalPromiseResult.data.length > 0 ? Object.keys(originalPromiseResult.data[0]) : []);
            setSelectedExportData(originalPromiseResult.data);
            setSelectedFileName(originalPromiseResult.FileName);
            setIsShowLoader(false);
          }
          else if (AccountReportId === '0acff3fc-5b4d-49b6-bea3-00af6ab896a7') {
            setSelectedColumnHeaders(originalPromiseResult.data.length > 0 ? Object.keys(originalPromiseResult.data[0]) : []);
            setSelectedExportData(originalPromiseResult.data);
            setSelectedFileName(originalPromiseResult.FileName);
            setIsShowLoader(false);
          }
          else {
            setIsConsolidated(originalPromiseResult.Data.isConsolidated);
            setReportColumnsDataArray(JSON.parse(originalPromiseResult.Data.reportColumnsData));
            setSelectedFilters(originalPromiseResult.Data.selectedFilters);
            if (JSON.parse(originalPromiseResult.Data.reportGroupData).length > 0) {

              setReportDataArrayDummy(JSON.parse(originalPromiseResult.Data.reportData));
              setReportGroupDataArray(JSON.parse(originalPromiseResult.Data.reportGroupData))
              //console.log(JSON.parse(originalPromiseResult.Data.reportGroupData),JSON.parse(originalPromiseResult.Data.reportData),"group")
              //const formattedData = formatReportDataForSpain(filteredData);
              const groupData = groupDataByMultipleColumns(JSON.parse(originalPromiseResult.Data.reportData), JSON.parse(originalPromiseResult.Data.reportGroupData), JSON.parse(originalPromiseResult.Data.reportSummaryData), "Amount", true);

              const reportData = JSON.parse(originalPromiseResult.Data.reportData);

              // Format TotalHours for each row in array
              /* const formattedReportData = reportData.map((item: any) => ({
                  ...item,
                  TotalHours: formatNumberCustomoriginal(
                      cultureInfoName.toString(),
                      item.TotalHours,
                      decimalPlaces
                  )
              })); */
              const groupJson = await getGroupJSON(
                JSON.parse(originalPromiseResult.Data.reportData),
                JSON.parse(originalPromiseResult.Data.reportGroupData),
                JSON.parse(originalPromiseResult.Data.reportSummaryData),
                JSON.parse(originalPromiseResult.Data.reportColumnsData),
                originalPromiseResult.Data.isConsolidated,
                originalPromiseResult.Data.imageURL,
                originalPromiseResult?.Data?.isShowLogoInReport
              )
              //console.log("originalPromiseResult.Data.reportGroupData v1", groupData)
              //const formattedData = formatReportDataForSpain(groupData);
              //console.log("originalPromiseResult.Data.formattedData v1", formattedData)
              setGroupData(groupJson);
              dispatch(updateOrigReportDataState(groupData));
              setReportDataArray(groupData);
              setOverallTotalsArray(overallTotals);
              setReportSummaryDataArray(JSON.parse(originalPromiseResult.Data.reportSummaryData));
              const id = JSON.parse(originalPromiseResult.Data.reportGroupData)?.[0]?.AccountReportId;
              const label = JSON.parse(originalPromiseResult.Data.reportGroupData)?.[0]?.ReportGroupFieldLabel;
              setReportId(id);
              setGroupReportLabel(label);
              setIsGeneratePdf(true);
              setIsShowLoader(false);
            }
            else {

              const data = JSON.parse(originalPromiseResult.Data.reportData);
              const simpleJson = await getSimpleJSON(JSON.parse(originalPromiseResult.Data.reportColumnsData), JSON.parse(originalPromiseResult.Data.reportData), JSON.parse(originalPromiseResult.Data.reportSummaryData));
              setSimpleData(simpleJson)
              setReportDataArrayDummy(data);
              dispatch(updateOrigReportDataState(data));
              setReportDataArray(data);
              setIsGeneratePdf(true);
              setIsShowLoader(false);
            }
          }
        }
        setIsFirstTimeLoad(false);
        setIIsGenerateReport(false);
        setIsShowLoader(false);
      })
      .catch((rejectedValueOrSerializedError) => {
        setIsShowLoader(false);
        setIsFirstTimeLoad(false);
        setIIsGenerateReport(false);
      })
  }

  // Function to format number to Spanish locale
  const formatToSpanishNumber = (value: number): string => {
    return value.toLocaleString('es-ES', {
      minimumFractionDigits: 1,
      maximumFractionDigits: 2
    });
  };

  // Usage example with your data structure
  const formatReportDataForSpain = (data: any) => {
    Object.keys(data).forEach(employeeKey => {
      const employee = data[employeeKey];

      // Format items
      if (employee.items && Array.isArray(employee.items)) {
        employee.items = employee.items.map((item: any) => ({
          ...item,
          TotalHours: formatToSpanishNumber(item.TotalHours),
          CurrencyEmployeeCost: formatToSpanishNumber(item.CurrencyEmployeeCost),
          CurrencyEmployeeRate: formatToSpanishNumber(item.CurrencyEmployeeRate),
          // Add other currency/numeric fields as needed
        }));
      }

      // Format totals
      if (employee.totals && employee.totals.TotalHours) {
        employee.totals.TotalHours = formatToSpanishNumber(employee.totals.TotalHours);
      }
    });

    return data;
  };

  // Apply to your filtered data



  const htmlToCsv = (html: string): string => {
    const doc = new DOMParser().parseFromString(html, 'text/html');
    const titleRow = doc.querySelector('h3');
    const rows = doc.querySelectorAll('table tr');

    let currentGroupValue = '';
    let csvData: string[] = [];
    let headerAdded = false;

    if (titleRow) {
      csvData.push(`"${titleRow.innerHTML}"`); // Wrap title in quotes
    }

    const headerRow = doc.querySelector('table thead tr');
    if (headerRow && !headerAdded) {
      const headerColumns = headerRow.querySelectorAll('th');
      let headerData = Array.from(headerColumns, th => `"${th.textContent?.trim() || ''}"`);
      csvData.push(headerData.join(','));
      headerAdded = true;
    }


    rows.forEach((row, rowIndex) => {

      if (rowIndex === 0 && row.querySelectorAll('th').length > 0) return;

      const columns = row.querySelectorAll('td');
      let rowData: string[] = [];

      columns.forEach((column) => {
        const colspan = parseInt(column.getAttribute('colspan') || '1');
        const className = column.getAttribute('class') || '';
        let cellValue = column.textContent?.trim() || '';
        cellValue = cellValue.replace(/"/g, '""');

        if (className === "group-td") {
          if (currentGroupValue !== cellValue) {
            rowData.push(`"${cellValue}"`);
            currentGroupValue = cellValue;
          } else {
            rowData.push('""');
          }
        } else {
          for (let i = 0; i < colspan; i++) {
            rowData.push(`"${cellValue}"`);
          }
        }
      });

      csvData.push(rowData.join(','));
    });

    return csvData.join('\n');
  };


  // Handle CSV download
  const handleHtmlToCSVDownload = () => {
    setIsLoadingLocal(true);
    setIscsvExport(true);
  };

  // Handle htmltoexcel download
  const handleHtmlToExcelDownload = () => {
    setIsLoadingLocal(true);
    setIsxlsExport(true);
  };
  const handleHtmlToPdfDownload = () => {
    setIsLoadingLocal(true);
    setIsPdfExport(true);
  };

  const generalObject = {
    "name": getValueFromResource('Filters', dispatch, t),
    "width": "700px",
    "componentName": <CustomReportFilter AccountReportId={AccountReportId} onHandleOnClickEvent={handleOnClickEvent} />
  }


  const findMaxPropertyLength = (array: any) => {

    let maxLength = 0;

    array.forEach((obj: any) => {
      Object.values(obj).forEach((value: any) => {
        const length = typeof value === 'string' ? value.length : 0;
        if (length > maxLength) {
          maxLength = length;
        }
      });
    });

    return maxLength;
  };

  // if (!state || !state.accountReportId) {
  //     navigate('../MyReports');
  //   }

  const dataFalg = Object.entries(groupData).length > 0 || Object.entries(simpleData).length > 0;
  useEffect(() => {
    if (dataFalg) {
      setIsShowLoader(false);
    }
  }, [dataFalg])

  const onhandleNavigate =()=>{
    navigate('/myreports', { state: { targetTab: 'Scheduled Reports' } });
  }
  const onClose = () => {
    setShowScheduleReport(false);
  }
  return (
    <>
      <div className="dummyTableContainer"
        ref={tableRef}
        style={{
          visibility: 'hidden',
          position: 'absolute',
          height: '0',
          width: '0'
        }}
      >
        {reportDataArrayDummy && reportDataArrayDummy.length > 0 &&
          <table >
            {reportColumnsDataArray.length > 0 &&
              <thead>

                <tr>
                  {Object.keys(reportColumnsDataArray[0]).map((item: any, index: any) => (
                    <th key={index}
                      style={{ maxWidth: `${item.SystemReportDataSourceFieldWidth}px`, width: `${item.SystemReportDataSourceFieldWidth}px`, backgroundColor: '#f0f1f4', borderLeft: '1px solid #ffffff', borderRight: '1px solid #ffffff', fontSize: '12px', fontWeight: '600' }}
                    >
                      {item.Caption}
                    </th>
                  ))}
                </tr>
              </thead>
            }
            {reportColumnsDataArray.length > 0 &&
              <tbody>
                {maxRowIndex !== -1 && (
                  <tr>
                    {reportColumnsDataArray.map((column: any, columnIndex: any) => (
                      <td key={columnIndex}
                        style={{
                          maxWidth: `${column.SystemReportDataSourceFieldWidth}px`,
                          width: `${column.SystemReportDataSourceFieldWidth}px`,
                          wordWrap: 'break-word',
                          overflowWrap: 'break-word'
                        }}>
                        <span className={`d-block `}>
                          {Object.values(reportDataArrayDummy[maxRowIndex])[columnIndex] as any}
                        </span>

                      </td>
                    ))}
                  </tr>
                )}
              </tbody>
            }
          </table>
        }
      </div>
      <div className="card card-custom admin-card">
        {/* {reportDataArrayDummy && reportDataArrayDummy.length > 0 && isShowLogoInReport &&
         <div style={{marginBottom: '-20px'}}>
            {isCompanyOwnLogo ?
              <img src={imageURL} className='tsReportIcon' style={{ width: '200px', height: '80px', paddingLeft: 20, marginBottom: 8 }} />
              :
              <>
                <img src={toAbsoluteUrl('/media/logos/LivetecsLogo.svg')} className='tsReportLogo' />
              </>
            }
          </div>
      } */}
        <div className="card-header sticky-top bg-white">
          <h3 className="card-title fw-bold headerTitle">{getValueFromResource(`${ReportName}`, dispatch, t)}</h3>
          <div className="card-toolbar align-items-center">
            {/* <div className="position-relative">
              <input
                type="text"
                value={searchTerm}
                onChange={handleSearch}
                placeholder=
                // {t('Search')}
                {getValueFromResource('Search', dispatch, t)}
                className="form-control h-35px w-200px fs-7 fw-normal pr-4"
                data-kt-user-table-filter="search"
              />
              <i className="ki-duotone ki-magnifier fs-5 position-absolute top-50 translate-middle-y end-0" style={{ marginRight: '10px' }}>
                <span className="path1"></span>
                <span className="path2"></span>
              </i>
            </div> */}
            <div className='h-35px w-1px mx-1'></div>
            {/* {(currentItems.length > 0 || totalPages > 0) ? ( */}
            <>
              {/* <div style={{ marginRight: '5px' }}> */}
              {/* {t('Page')} */}
              {/* {getValueFromResource('Page', dispatch, t)}
                </div> */}
              {/* <div className="d-flex align-items-center" style={{ marginRight: '5px' }}>
                  <Select
                    styles={paginationStyles}
                    options={pageOptions}
                    value={pageOptions.find((option: any) => option.value === currentPage)}
                    onChange={handlePageChange}
                    className='fs-7 fw-normal'
                  />
                </div> */}
              {/* <div>
                  of {totalPages}
                </div> */}
              {/* <div className="d-flex align-items-center"> */}
              {/* <ul className="pagination"> */}
              {/* <li className="page-item previous" style={currentPage === 1 ? { pointerEvents: 'none', marginRight: '0px', marginLeft: '5px' } : { pointerEvents: 'initial', marginRight: '0px', marginLeft: '5px' }}
                      onClick={() => handlePageChange({ value: currentPage - 1, label: currentPage - 1 })}  >
                      <a className="page-link" style={{
                        borderTopRightRadius: '0px',
                        borderBottomRightRadius: '0px',
                        borderTopLeftRadius: '5px',
                        borderBottomLeftRadius: '5px',
                      }}>
                        <i className="previous" ></i>
                      </a>
                    </li> */}
              {/* <li className="page-item next" style={(currentPage * pageSize >= totalPages) ? { pointerEvents: 'none' } : { pointerEvents: 'initial' }}
                      // onClick={() => handlePageChange(currentPage + 1)}
                      onClick={() => handlePageChange({ value: currentPage + 1, label: currentPage + 1 })}
                    >
                      <a className="page-link" style={{
                        borderTopLeftRadius: '0px',
                        borderBottomLeftRadius: '0px',
                        borderTopRightRadius: '5px',
                        borderBottomRightRadius: '5px',
                      }}>
                        <i className="next"></i>
                      </a>
                    </li> */}
              {/* </ul> */}
              {/* </div> */}
            </>
            {/* // ) : null} */}
            <a
              className={`btn btn-icon btn-active-light-dark btn-sm ms-0 ${isGenerateReportActive ? 'active' : ''}`}
              data-tooltip-id="tooltip-Description"
              data-tooltip-content=
              // {t("Generate Report")}
              {getValueFromResource('Customize Report', dispatch, t)}
              data-tooltip-place="bottom"
              onClick={() => navigate(`/customreportdesign/${AccountReportId}?from=scheduleCustomize`,{state: {tabStepper: 2}})}
            >
              <i className={`bi bi-pencil-square fs-2 iconColor active`}></i>
            </a>
            <div className='bullet bg-secondary h-35px w-1px mx-3'></div>
           {showScheduleTab && (
            <>
           <a
              className={`btn btn-icon btn-active-light-dark btn-sm ms-0 ${isGenerateReportActive ? 'active' : ''}`}
              data-tooltip-id="tooltip-Description"
              data-tooltip-content=
              // {t("Generate Report")}
              {getValueFromResource('Schedule Report', dispatch, t)}
              data-tooltip-place="bottom"
              onClick={() => setShowScheduleReport(true)}
            >
              <i className={`ki-outline ki-calendar fs-1 iconColor active`}></i>
            </a>
            <div className='bullet bg-secondary h-35px w-1px mx-3'></div>
            </>
           )}
            <a
              className={`btn btn-icon btn-active-light-dark btn-sm ms-0 ${isGenerateReportActive ? 'active' : ''}`}
              data-tooltip-id="tooltip-Description"
              data-tooltip-content=
              // {t("Generate Report")}
              {getValueFromResource('Generate Report', dispatch, t)}
              data-tooltip-place="bottom"
              onClick={handleOnClickEvent}
            >
              <i className={`bi bi-file-text fs-3 iconColor ${isGenerateReportActive ? 'active' : ''}`}></i>
            </a>
            <div className='bullet bg-secondary h-35px w-1px mx-3'></div>
            <a
              id="kt_OffCanvas"
              //className={`btn btn-icon btn-active-light-dark btn-sm ms-0 ${isActive ? 'active' : ''}`}
              className={`btn btn-icon btn-active-light-dark btn-sm ms-0`}
              data-tooltip-id="tooltip-Description"
              data-tooltip-content=
              // {t("Filters")}
              {getValueFromResource('Filters', dispatch, t)}
              data-tooltip-place="bottom"
            //onClick={() => handleToggleAdvancedFilters()}
            >
              <i className={`bi bi-filter fs-3 iconColor `}
              // onClick={() => handleToggleAdvancedFilters()}
              ></i>
            </a>
            {Object.keys(reportDataArray).length > 0 &&
              (
                <></>

              )
            }
          </div>

        </div>
        <div className="card-body ">
          {(isShowLoader) && <Loader />}
          <div className="table-responsive" ref={contentRef} style={{ overflowX: 'scroll' }}>
            {(Object.entries(groupData).length > 0 && reportDataArrayDummy.length > 0) ? (

              <MUITableView
                table={groupData}
                reportName={ReportName}
                selectedFilters={selectedFilters}
              />

            ) : (Object.entries(simpleData).length > 0 && reportDataArrayDummy.length > 0) ? (
              <MUISimpleTableView
                table={simpleData}
                reportName={ReportName}
                selectedFilters={selectedFilters}
                showCompanyLogo={isShowLogoInReport}
                companyLogo={logoURL}
              />
            ) : (
              <div className="overflow-auto pb-5">
                <div className="notice d-flex bg-light-primary rounded border-primary border border-dashed min-w-lg-600px flex-shrink-0 p-6">
                  {isFirstTimeLoad ? (
                    <>
                      <i className="bi bi-file-text fs-1 text-primary me-2 mt-2">
                        <span className="path1"></span>
                        <span className="path2"></span>
                        <span className="path3"></span>
                      </i>
                      <div className="d-flex flex-stack flex-grow-1 flex-wrap flex-md-nowrap">
                        <div className="mb-3 mb-md-0 fw-semibold">
                          <h4 className="text-gray-900 fw-bold">
                            {/* {t('Generate Reports')} */}
                            {getValueFromResource('Generate Reports', dispatch, t)}
                          </h4>
                          <div className="fs-7 text-gray-600 pe-7">
                            {/* {t("Please Click On 'Generate Report' Button On The Top Right Corner To See Your Report")} */}
                            {getValueFromResource('Please Click On "Generate Report" Button On The Top Right Corner To See Your Report', dispatch, t)}
                          </div>
                        </div>
                      </div>
                    </>
                  ) : (
                    <div className="mb-3 mb-md-0 fw-semibold">
                      <div className="fs-7 text-gray-600 pe-7 ">
                        {/* {t('No Data Match Your Criteria. Try Different Filters')} */}
                        {getValueFromResource('No Data Match Your Criteria. Try Different Filters', dispatch, t)}
                      </div>
                    </div>
                  )}
                </div>
              </div>
            )}
          </div>
        </div>
      </div >
      <OffCanvas obj={generalObject} />
      <br></br>
      {(isPdfExport || iscsvExport || isxlsExport || true) &&
        <div className="table-responsive" ref={contentRef1}
          style={{
            // visibility: 'hidden',
            position: 'absolute',
            height: '0',
            width: '0',
            overflow: 'hidden'
          }}

        >
          <div className="table-responsive">
            {reportDataArrayDummy && reportDataArrayDummy.length > 0 && isShowLogoInReport &&
              <div>
                {isCompanyOwnLogo ?
                  <img
                    src={logoURL}
                    alt="Company Logo"
                    style={{
                      width: '200px',
                      height: '80px',
                      paddingLeft: 0,
                      marginBottom: 0
                    }}
                    onLoad={handleImageLoad}
                  />
                  :
                  <>
                    <img src={toAbsoluteUrl('/media/logos/LiveTecs_new-logo.png')} style={{
                      width: '200px',
                      height: '80px',
                      paddingLeft: 0,
                      marginBottom: 0
                    }} />
                  </>
                }
              </div>

            }
          </div>
          <h3 id='reportTitle' className="reportTitle card-title fw-bold headerTitle">{getValueFromResource(`${ReportName}`, dispatch, t)}</h3>
          <div id='filterdisplay' className="filter-display">
            <h4 className=" card-title fw-bold headerTitle">
              {/* {('Selected Filters:')} */}
              {getValueFromResource('Selected Filters:', dispatch, t)}
            </h4>
            <ul>
              {selectedFilters.map((filter: any, index: any) => (
                <li key={index}>{filter}</li>
              ))}
            </ul>
          </div>

          {/* <DynamicTable
            TableData={reportDataArray}
            reportGroupDataArray={reportGroupDataArray}
            reportColumnsDataArray={reportColumnsDataArray}
            overallTotalsArray={overallTotalsArray}
            reportSummaryDataArray={reportSummaryDataArray}
            isConsolidated={isConsolidated}
          /> */}

        </div>
      }
      <CSVLink data={SelectedExportData} headers={SelectedColumnHeaders} filename={SelectedFileName} ref={csvLinkRef}  >

      </CSVLink>
      {showScheduleReport && <ScheduleReport onClose={onClose} AccountReportId={AccountReportId}  moveTo={'myReport'} onhandleNavigate={onhandleNavigate}/>}
    </>
  )
}